import React, { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';

const Map = () => {
    const isDesktop = useMediaQuery({ query: '(min-width: 1440px)' });
    const isTablet = useMediaQuery({ query: '(min-width: 768px)' });
    const isMobile = useMediaQuery({ query: '(max-width: 767px)' });
    const [widthMap, setWidthMap] = useState("800");

    useEffect(() => {
        if (isDesktop) setWidthMap("800");
        else if (isTablet) setWidthMap("450");
        else if (isMobile) setWidthMap("100%");
    }, [isDesktop, isTablet, isMobile]);
    return (
        <div>
            <iframe
                title='1'
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1159.4494026416878!2d17.028207038878712!3d54.46472205207056!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46fe10a739b0907f%3A0xe6234c251d433f19!2zV8WCYWR5c8WCYXdhIEphZ2llxYLFgnkgMywgNzYtMjAwIFPFgnVwc2s!5e0!3m2!1spl!2spl!4v1791114997319!5m2!1spl!2spl"
                width={widthMap}
                height="545"
                allowFullScreen=""
                loading="lazy"
                style={{ border: 0 }}
            ></iframe>
        </div>
    )
};

export default Map;